import React from 'react';
import { Carousel } from 'react-bootstrap';
import ButtonLink from '../components/ButtonLink';
import '../assets/css/font.css';
import hero1 from '../assets/img/hero1.jpg';
import hero2 from '../assets/img/hero2.jpg';
import hero3 from '../assets/img/hero3.jpg';

const HeroSection = () => {
  const products = [
    {
      id: 1,
      img: hero1,
      title: 'Building Excellence, Every Step of the Way',
      discription: 'Crafting tailored solutions for residential and commercial projects with a commitment to quality, innovation, and reliability.',
      link:'/service'
    },
    {
      id: 2,
      img: hero2,
      title: 'Transforming Ideas into Reality',
      discription: 'Delivering expert construction services to bring your dream spaces to life, from concept to completion. ',
      link:'/gallery'
    },
    {
      id: 3,
      img: hero3,
      title: 'Trusted Construction Solutions',
      discription: 'Reliable and professional services for residential and commercial projects, built to perfection.',
      link:'/contact'
    },
  ];

  return (
    
      <Carousel fade interval={3000} className='hero-img'>
        {products.map((product) => (
          <Carousel.Item key={product.id}>
            <img
              className="d-block w-100"
              src={product.img}
              alt={product.title}
            />
            
            <Carousel.Caption className="hero-info">
                    <h1>{product.title}</h1>
                    <p>{product.discription}
                    </p>
                    <ButtonLink link={product.link} name="Read more" />
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
  );
};

export default HeroSection;
